<script>
import { mapActions } from 'vuex';
import kebabCase from 'lodash/kebabCase';

import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Pages'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Pages',
            includeDeleteAction: false,
            customSortBy: ['language.code:ASC']
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                { value: 'key', width: '150px' },
                {
                    text: 'Language',
                    value: 'language.code',
                    type: 'enum',
                    isLanguage: true,
                    enumOptions: [
                        { value: 'he', label: 'Hebrew' },
                        { value: 'en', label: 'English' },
                        { value: 'ar', label: 'Arabic' },
                        { value: 'ru', label: 'Russian' }
                    ]
                },
                {
                    text: 'Page Type',
                    value: 'type',
                    type: 'enum',
                    enumOptions: ['page', 'component'],
                    width: '150px'
                },
                {
                    text: 'Full URL',
                    value: 'fullUrl',
                    filter: 'getUrl',
                    width: '150px',
                    skipValue: true,
                    sortable: false,
                    filterable: false,
                    filterOptions: {
                        type: 'page',
                        incudeFullUrl: true
                    }
                },
                {
                    text: 'URL Path',
                    filter: 'getUrl',
                    value: 'urlPath',
                    width: '150px',
                    skipValue: true,
                    sortable: false,
                    filterable: false,
                    filterOptions: {
                        type: 'page'
                    }
                }
            ];
        },

        options() {
            return {
                addButton: false
            };
        }
    },

    methods: {
        ...mapActions({
            getItems: 'contents/index'
        }),

        onRowClick({ key }) {
            this.$router.push(`/contents/${kebabCase(key)}`);
        }
    }
};
</script>
